import GeoJSONLayer from "@arcgis/core/layers/GeoJSONLayer";
import PictureMarkerSymbol from "@arcgis/core/symbols/PictureMarkerSymbol";
import arrowPNG from '../../../../assets/images/arrow.png';
import RotationVariable from "@arcgis/core/renderers/visualVariables/RotationVariable";
import UniqueValueRenderer from '@arcgis/core/renderers/UniqueValueRenderer';
import SimpleMarkerSymbol from '@arcgis/core/symbols/SimpleMarkerSymbol';

const checkNull = (value:any)=>{
    if(value===null){
        return 0
    }
    else{
        return 1
    }
}

export const formatWindArrowLayer = (data:any[], zoom: number, startDate: any, endDate: any, radio:string )=>{

    const arrowGeojson = {
        type: "FeatureCollection",
        features: data.map((item) => ({
            type: "Feature",
            geometry: {
                type: "Point",
                coordinates: [item.longitude, item.latitude]
            },
            properties: {
                val: radio ==='hourly'? checkNull(item.wind_direction):checkNull(item.peak_wind_gust_direction),
                image_url: radio ==='hourly'? item.wind_direction && arrowPNG: item.peak_wind_gust_direction && arrowPNG,
                rotation: radio === 'hourly'? item.wind_direction && Number(item.wind_direction) +90:item.peak_wind_gust_direction&& Number(item.peak_wind_gust_direction)+90,
                elevation: item.elevation,
                network: item.network_name,
                state: item.state,
                has_historic_data: (item.has_historic_data).toString().toLowerCase()==='true'?1:0
            }
        }))
    };
    const arrowBlob = new Blob([JSON.stringify(arrowGeojson)], {
        type: "application/json"
    });
    const arrowUrl = URL.createObjectURL(arrowBlob);
    const windDirGeojsonLayer = new GeoJSONLayer({
        url: arrowUrl,
        id: `windDirectionArrows&Zoom=${zoom}&StartDate=${startDate}&EndDate=${endDate}`,
    });
    const symbol = new PictureMarkerSymbol({
        url: arrowPNG,
        height:20,
        width:20,
        xoffset: 16,
    });
    const rotVariable = new RotationVariable({
        field: "rotation",
        rotationType: "geographic"
    });

    const defaultSymbol = new SimpleMarkerSymbol({
        size: "0"
    });
    
    const windDirRenderer = new UniqueValueRenderer({
        field: 'val',
        uniqueValueInfos:[{
                value: 0,
                symbol: defaultSymbol
            },
            {
                value: 1,
                symbol: symbol
            }
        ],
        visualVariables:[rotVariable],
    });
    windDirGeojsonLayer.renderer = windDirRenderer;

    return windDirGeojsonLayer;

}